import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CookieBanner } from "./CookieBanner";

export const useSeo = (title, description) => {
  useEffect(() => {
    document.title = `${title} | Habitalys`;
    let m = document.querySelector('meta[name="description"]');
    if (!m) { m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); }
    if (description) m.setAttribute("content", description);
  }, [title, description]);
};

export const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col overflow-x-clip">
      <Header />
      <main id="main" className="flex-1" tabIndex={-1}><Outlet /></main>
      <Footer />
      <CookieBanner />
    </div>
  );
};
